<template>
  <el-aside style="width: 200px; height: 100%; background: #fff;">
    <el-menu :default-active="navActive" background-color="#fff" text-color="#333" active-text-color="#333" style="border: none;" router>
      <el-submenu index="1" class="submenu-title">
        <template slot="title"><span style="font-size: 16px;font-weight: bold;color: #FFFFFF">{{ navTitle }}</span></template>

        <!-- 一级菜单 -->
        <template v-for="item in menuItems">
          <el-submenu v-if="item.children && item.children.length" :key="item.index" :index="item.index">
            <template slot="title"><span style="color: #333;font-weight: bold;">{{item.name}}</span></template>

            <!-- 二级菜单 -->
            <template v-for="itemChild in item.children">
              <el-submenu v-if="itemChild.children && itemChild.children.length" :key="itemChild.index" :index="itemChild.index">
                <template slot="title"><span>{{itemChild.name}}</span></template>
              </el-submenu>

              <el-menu-item v-else :key="itemChild.index" :index="itemChild.index" :route="itemChild.route"><span slot="title">{{itemChild.name}}</span></el-menu-item>
            </template>
          </el-submenu>

          <el-menu-item v-else :key="item.index" :index="item.index" :route="item.route"><span slot="title">{{item.name}}</span></el-menu-item>
        </template>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  props: ['nav-title', 'nav-active', 'menu-items']
}
</script>

<style scoped>
.el-menu-item.is-active {
  background-color: #F9F9F9 !important;
  border-left: 5px solid #5E93F6 !important;
}
.el-aside /deep/ .el-submenu__title {
  /* background-color: #5E93F6 !important; */
  height: 50px !important;
  line-height: 50px !important;
  color: #fff !important;
  /* reset to the same padding */
  padding-left: 20px !important;
}
.el-menu-item {
  padding-left: 20px !important;
}
.el-aside /deep/ .submenu-title > .el-submenu__title {
  background-color: #5E93F6 !important;
}
.el-aside /deep/ .el-submenu {
  border-bottom: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Navigator.vue